import ruMinesTranslations from './i18n/ru.json'
import enMinesTranslations from './i18n/en.json'
import ukMinesTranslations from './i18n/uk.json'
import ptMinesTranslations from './i18n/pt.json'
import esMinesTranslations from './i18n/es.json'
import trMinesTranslations from './i18n/tr.json'
import kkMinesTranslations from './i18n/kk.json'
import uzMinesTranslations from './i18n/uz.json'
import idMinesTranslations from './i18n/id.json'
import tgMinesTranslations from './i18n/tg.json'
import kyMinesTranslations from './i18n/ky.json'
import arMinesTranslations from './i18n/ar.json'
import faMinesTranslations from './i18n/fa.json'

export const minesResources = {
  ru: ruMinesTranslations,
  en: enMinesTranslations,
  uk: ukMinesTranslations,
  pt: ptMinesTranslations,
  es: esMinesTranslations,
  tr: trMinesTranslations,
  kk: kkMinesTranslations,
  uz: uzMinesTranslations,
  id: idMinesTranslations,
  tg: tgMinesTranslations,
  ky: kyMinesTranslations,
  ar: arMinesTranslations,
  fa: faMinesTranslations
}
